import {
  requestGet,
  requestGetForm,
  requestPost,
  requestPostForm
} from "../config/http-json";
import log from "@/util/log";

const writer = {
  async selectCustomFirmwareSettings() {
    let response = await requestGetForm(
      "/waveWriter/curve/selectCustomFirmwareSettings",
      {},
      { showLoading: false }
    );
    return response.data;
  },
  async selectRecommendSettingsDetails(params = {}) {
    let response = await requestGetForm(
      "/waveWriter/curve/selectRecommendSettingsDetails",
      params,
      { showLoading: false }
    );
    return response;
  },
  async selectMySettingsDetails(params = {}) {
    let response = await requestGetForm(
      "/waveWriter/curve/selectMySettingsDetails",
      params,
      { showLoading: false }
    );
    return response;
  },
  async saveUseSettings(params = {}) {
    let response = await requestPost("/waveWriter/curve/saveUseSettings", params);
    return response;
  },
  async selectFlavorByRecommend(params = {}) {
    let response = await requestGetForm(
      "/waveWriter/curve/selectFlavorByRecommend",
      params
    );
    return response;
  },
  async selectCurveById(params = {}) {
    let response = await requestGetForm("/waveWriter/curve/selectCurveById", params);
    return response;
  },
  async updateVoltageName(params = {}) {
    let response = await requestPost("/waveWriter/curve/updateVoltageName", params);
    return response;
  },
  async deleteCurveById(params = {}) {
    let response = await requestPostForm("/waveWriter/curve/deleteCurveById", params);
    return response;
  },
  async selectAllFlavor(params = {}) {
    let response = await requestGetForm("/waveWriter/curve/selectAllFlavor", params);
    return response;
  },
  async saveVoltageSettings(params = {}) {
    let response = await requestPost("/waveWriter/curve/saveVoltageSettings", params);
    return response;
  },
  async uploadConfig(
    modeId,
    modeName,
    resistance,
    maxPower,
    deviceIdentification,
    macAddress,
    firmwareVersion,
    softwareVersion,
    writeSetting,
    smokeRecordNumber,
    nameIdentification = "HB"
  ) {
    let params   = {
      deviceIdentification: deviceIdentification,
      deviceNumber: macAddress,
      firmwareVersion: firmwareVersion,
      softwareVersion: softwareVersion,
      nameIdentification: nameIdentification,
      useVersion: 1,
      modeId,
      modeName,
      nfcSettings: writeSetting.isSupportNfc ? 1 : 0,
      preheatSetting: writeSetting.isSupportPreheat ? 1 : 0,
      preheatVoltage: writeSetting.preheatVoltage,
      preheatTouches: writeSetting.preheatCount,
      preheatTime: writeSetting.preheatTime,
      touchLight: writeSetting.isSupportLight ? 1 : 0,
      heatingVoltage: writeSetting.diyVoltage
        .map((item) => Math.abs(item))
        .join(","),
      microphoneSensitivity: writeSetting.micSensitivity,
      touchSensitivity: writeSetting.touchSensitivity,
      smokeRecordNumber,
      showLoading: false
    };
    let response = await requestPost("/waveWriter/curve/uploadFirmwareSetting", params);
    return response;
  },
  async curveHistory(pageNum) {
    let response = await requestGetForm(
      "/waveWriter/curve/selectUploadHistory",
      { pageNum, pageSize: 10 },
      { showLoading: false }
    );
    return response;
  },
  async replacementDeviceInfo(tagId) {
    let response = await requestGetForm(
      "/waveWriter/curve/selectQrCodeDetails",
      { tagId },
      { showLoading: false }
    );
    return response.data;
  },

  async activeTag(modelCode) {
    const data = await requestPostForm("/front/user/userActivateTag", { tagId: modelCode.toUpperCase() }, { showProgress: false });
    log("ret=", data);
    return data.data;
  },

  async productInfo(modelCode) {
    const data = await requestGetForm("/front/shard/findModelByCode", { tagId: modelCode.toUpperCase() }, { showProgress: true });
    log("ret=", data);
    return data.data;
  },

  async liquidVoltageList(codeContent, resistance,tag) {
    const data = await requestGetForm("/waveWriter/curve/selectVoltageList", {
      codeContent,
      resistance,
      tag
    }, { showProgress: true });
    log("ret=", data);
    return data.data;
  },
  async updateOilFlavor(oilResistanceId, tag) {
    const data = await requestPostForm("/waveWriter/curve/updateOilFlavor", {
      oilResistanceId,
      tag
    });
    log("ret=", data);
    return data.data;
  }
};

export default writer;
